// The admin's single « is this a phone? » switch.
//
// Shared contract (plan 2026-10-01-app-feel): phone = max-width 767px, the
// same line as Tailwind's `md:`. Pages that swap a wide table for stacked cards
// render EITHER one or the other from this hook — never both behind
// `hidden md:block` — because a row often owns a portalled menu or a confirm
// dialog, and two live copies of those are a real bug, not just extra DOM.
import { useEffect, useState } from 'react';

export const PHONE_QUERY = '(max-width: 767px)';

export function useIsPhone(): boolean {
  const [phone, setPhone] = useState(
    () => typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(PHONE_QUERY).matches,
  );
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(PHONE_QUERY);
    const onChange = (e: MediaQueryListEvent) => setPhone(e.matches);
    mq.addEventListener('change', onChange);
    setPhone(mq.matches);
    return () => mq.removeEventListener('change', onChange);
  }, []);
  return phone;
}
